
<mat-dialog-content style="padding-bottom: 0">
    <div id="tituloReclamacion">
      <h2>Petición {{titulo}}</h2>
      <span style="flex: 1 1 auto;"></span>
    </div>
    <mat-form-field appearance="fill" id="selectMotivo">
      <mat-label>Motivo de reclamacion</mat-label>
        <mat-select [(ngModel)]="selectedMotivo">
          <mat-option *ngFor="let motivo of motivosAnula" [value]="motivo[0]" style="color: #294634!important;">
            {{ motivo[1] }}
          </mat-option>
      </mat-select>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions id="botonesReclamar" align="center" style="margin-bottom: 20px;">
  <a style="width: 20%;" class="btnStyle btnClose" mat-flat-button (click)="onClose('close')">Cerrar</a>
  <a style="width: 20%;" class="btnStyle btnPrin" mat-flat-button (click)="onClose('reclaim')" >{{buttonText}}</a>
</mat-dialog-actions>

